<!--
  新建 合同订单特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 合同模板 -->
    <template v-if="item.attr === 'templateId'">
      <el-select v-model="form[item.attr]" @change="handleTemp" :disabled="item.nonEditable===1" placeholder="请选择">
        <el-option
          v-for="arr in item.valueArrMap"
          :key="arr.key"
          :label="arr.value"
          :value="arr.key">
        </el-option>
      </el-select>
    </template>
    <!-- 关联客户 -->
    <template v-else-if="item.attr === 'customerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        @emitObj="changeCustomer"
        >
      </associated-field>
    </template>
    <!-- 关联机会 -->
    <template v-else-if="item.attr === 'opportunityId'">
      <associated-field
        ref="associatedField"
        v-if="form.customerName.id"
        module="opportunityApi"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        @addNew="addNew"
        >
      </associated-field>
      <span v-else>无</span>
    </template>
    <!-- 合作客户 -->
    <template v-else-if="item.attr === 'partnerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        >
      </associated-field>
    </template>
    <!-- 联系人 -->
    <template v-else-if="item.attr === 'contactName'">
      <associated-field
        ref="associatedField"
        v-if="form.customerName.id"
        module="contactApi"
        :multiselect="false"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        @addNew="addNew"
        >
      </associated-field>
      <span v-else>无</span>
    </template>
    <!-- 签订人 -->
    <template v-else-if="item.attr === 'signPerson'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
      <div class="prompt">目标PK、绩效PK等数据统计时，合同金额绩效归属于“签订人”。</div>
    </template>
    <!-- 供货产品 -->

    <template v-else-if="item.attr === 'products'">
      <div class="products type2">
        <input type="text" placeholder="暂无关联产品" :value="Products.productList | productLen" class="v-input" readonly>
        <div class="v-area">
          <template v-if="Products.productList && Products.productList.length">产品合计(元)：{{Products.productList | totalPrice}}；<span v-for="item in Products.surchargeList" :class="{'discount':item.surchargeType === 2}">{{item.surchargeName}}(元)：{{item.amount | fiexd}} ; </span></template>
          <template v-else>产品合计(元)：0元；其它费用：0元</template>
        </div>
        <span class="add-btn" @click="emitParent">选择</span>
      </div>
    </template>
    <!-- 回款计划 -->
    <template v-else-if="item.attr === 'payment'">
      <payment-box
        ref="paymentBox"
        :moduleName="'contractApi'"
        :contractNo="form['contractNo']"
        :contractId="this.detailId || 0"
        :totalMoney="form['totalMoney']"
      >
      </payment-box>
    </template>
    <!-- 合同-查重 -->
    <div class="customerName" v-else-if="item.attr === 'name'">
      <el-input
        v-model="form[item.attr]"
        @focus="repeatListShow = true"
        @blur="repeatListShow = false"
        >
      </el-input>
      <div class="repeat-list" v-show="isNameCheck && repeatListShow">
        <h4 class="title" v-show="listData.length">已存在以下合同，请勿重复添加</h4>
        <ul>
          <li class="item" v-for="item in listData">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <!-- 其他 -->
    <template v-else>{{item.attr}}</template>
  </div>
</template>

<script>
import * as utils from 'src/utils'
import vManager from '../manager'
import paymentBox from '../payment/index'
import remoteSelect from '../remote-select'
import associatedField from '../associated-field'
let initProducts = {
  'productList': [],
  'surchargeList': []
}

export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    form: {
      type: Object,
      default: {}
    },
    isNameCheck: {
      type: Boolean,
      default: false
    },
    listData: {
      type: Array,
      default: []
    },
    detailId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      Products: this.form.products || initProducts,
      repeatListShow: false
    }
  },
  computed: {
  },
  methods: {
    // 重置关联单据
    changeCustomer () {
      this.form.contactName = ''
      this.form.opportunityId = ''
    },
    emitParent () {
      let type = 'add'
      if (this.Products.productList.length) {
        type = 'edit'
      }
      this.$emit('showProduct', type)
    },
    addNew (arr) {
      console.log(arr)
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    },
    // 监听选择框的变化
    handleTemp (value) {
      this.$emit('change', value, 'temp')
    }
  },
  components: {
    vManager,
    paymentBox,
    remoteSelect,
    associatedField
  },
  filters: {
    productLen (arr) {
      if (arr && arr.length) {
        let num = 0
        for (let i = 0; i < arr.length; i++) {
          num = utils.plus(num, arr[i].num)
        }
        return `${arr.length}种产品${num}件`
      }
    },
    fiexd (value) {
      return Number((parseFloat(value) > 0 ? parseFloat(value) : -parseFloat(value) || 0).toFixed(6))
    },
    totalPrice (arr) {
      let price = 0
      if (arr && arr.length) {
        for (let i = 0; i < arr.length; i++) {
          price = price + parseFloat(arr[i].productPrice) * parseFloat(arr[i].num)
        }
        return Number(price.toFixed(6))
      }
    }
  },
  watch: {
    form: {
      handler () {
        if (this.form.products) {
          this.Products = this.form.products
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
  .prompt {
    font-size: 10px;
    color: #8D8F92;
  }
  .products .discount {
    color: #ff6161;
  }
  .repeat-list {
    position: absolute;
    width: 250px;
    max-height: 300px;
    background-color: #fff;
    z-index: 100;
    overflow: auto;
    box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
    left: 2px;
    top: 40px;
    .title {
      font-size: 14px;
      line-height: 32px;
      border-bottom: 1px solid #ededed;
      padding-left: 10px;
    }
    .item {
      line-height: 28px;
      padding: 0 10px;
      color: #888;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?093a6d18